<div class="min-h-screen bg-gray-100 flex items-center justify-center p-4" data-testid="custom-login-page">
  <div class="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-200 p-8">
    <div class="text-center mb-6">
      <div class="flex justify-center mb-4">
        <app-company-logo [showText]="false"></app-company-logo>
      </div>
      <h1 class="text-2xl font-bold text-slate-800">Sign in</h1>
      <p class="text-slate-500 text-sm mt-1">Access your dashboard</p>
    </div>

    <form (ngSubmit)="checkUser()">
      <div class="my-3">
        <label class="block text-sm font-medium text-slate-700 mb-1">Email</label>
        <input
          [(ngModel)]="email"
          type="email"
          name="email"
          autocomplete="email"
          class="w-full border rounded px-3 py-2 focus:ring focus:border-blue-500"
          placeholder="you@company.com"
          required
          data-testid="login-email-input"
        />
      </div>

      <app-pan-button
        type="submit"
        color="primary"
        expand="block"
        class="mt-4"
        [disabled]="loading()"
        [state]="loading() ? 'loading' : 'default'"
        data-testid="login-continue-button"
      >
        Continue
      </app-pan-button>
    </form>

    <div class="text-center mt-6 text-slate-400 text-xs">Your login method will be selected automatically</div>
  </div>
</div>
